import { StateInterface } from "./state";
import { ProjectModel } from "../models";

export default {
  allProjects(state: StateInterface): ProjectModel[] {
    return state.projects;
  },
  allSubscriptions(state: StateInterface): ProjectModel[] {
    return state.subscriptions;
  },
  activeSubscriptions(state: StateInterface): ProjectModel[] {
    return state.subscriptions.filter((s): boolean => s.isActive());
  },
  lastFive(state: StateInterface): ProjectModel[] {
    return state.projects
      .sort((a, b): number => {
        if (a.projectId > b.projectId) return -1;
        if (a.projectId < b.projectId) return 1;
        return 0;
      })
      .slice(0, 5);
  },
};
